export enum InputValidationErrorCode {
  NonPhysicalAddress = 'non-physical-address',
}
